"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propType = exports.Provider = exports.Consumer = exports.PanelContext = exports.defaultPanelContext = exports.types = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var types = {
  inPanel: _propTypes.default.bool.isRequired
};
exports.types = types;
var defaultPanelContext = {
  inPanel: false
};
exports.defaultPanelContext = defaultPanelContext;
var PanelContext = (0, _react.createContext)(defaultPanelContext);
exports.PanelContext = PanelContext;
var Consumer = PanelContext.Consumer,
    Provider = PanelContext.Provider;
exports.Provider = Provider;
exports.Consumer = Consumer;

var propType = _propTypes.default.shape(types);

exports.propType = propType;